import React from "react";
import { IAppEntity } from "../../entities";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { VatTypeEnum } from "../../../enums/VatTypeEnum";
import { CommodityWaybillsDetail } from "src/components/Pages/Documents/CommodityWaybills/components/CommodityWaybillsDetail";
import CommodityWaybillsList from "src/components/Pages/Documents/CommodityWaybills/components/CommodityWaybillsList";
import { NFLookupCommodityWaybills } from "src/components/Shared/NewForms/NFLookupCommodityWaybills";
import { CommodityWaybillsService } from "src/services/documents/CommodityWaybillsService";
import { CreateCommodityWaybillsDto } from "src/components/Pages/Documents/CommodityWaybills/dtos/CreateCommodityWaybillsDto";

export const CommodityWaybills: IAppEntity = {
  entityType: "document",
  title: "Commodity Waybills",
  pluralTitle: "Commodity Waybills",
  apiUrl: "CommodityWaybills",
  apiEnum: ReferenceTypes.DocumentCommodityWaybill,
  getDetailView: (id?: string) => {
    return React.createElement(CommodityWaybillsDetail, {
      id: id
    });
  },
  getDetailViewComponent: (model: any, modelUpdatedEvent: (model: any) => void) => React.createElement(React.Fragment, {}),

  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(CommodityWaybillsList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupCommodityWaybills, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog
    });
  },
  getDataService: () => new CommodityWaybillsService("CommodityWaybills"),
  getEmptyModel: () => {
    const model: CreateCommodityWaybillsDto = {
      totalAmount: 0,
      totalAmountVat: 0,
      status: 0,

      documentDate: new Date(),
      createdDate: new Date(),
      // products: [],
      // services: [],
      // paymentOffsets: []
    };
    return model;
  }
};
